import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const categoryList = [
  {
    key: 'categories.shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20white%20leather%20sneakers%20with%20minimal%20design%20placed%20on%20a%20clean%20light%20grey%20studio%20surface%20soft%20natural%20daylight%20gentle%20shadows%20minimalist%20editorial%20product%20photography%20high%20detail%20harmonious%20composition&width=400&height=300&seq=cat-shoes-01&orientation=landscape',
  },
  {
    key: 'categories.hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20folded%20beige%20oversized%20hoodie%20sweatshirt%20on%20a%20light%20cream%20wooden%20table%20soft%20warm%20natural%20window%20light%20minimalist%20fashion%20flat%20lay%20editorial%20style%20clean%20composition%20warm%20neutral%20tones&width=400&height=300&seq=cat-hoodies-01&orientation=landscape',
  },
  {
    key: 'categories.tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Three%20neatly%20folded%20pastel%20colored%20cotton%20t-shirts%20stacked%20on%20a%20white%20surface%20soft%20diffused%20daylight%20minimalist%20apparel%20photography%20clean%20studio%20background%20editorial%20product%20style&width=400&height=300&seq=cat-tshirts-01&orientation=landscape',
  },
  {
    key: 'categories.jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20green%20bomber%20jacket%20hanging%20on%20a%20minimal%20wooden%20hanger%20against%20a%20soft%20grey%20wall%20gentle%20natural%20light%20minimalist%20fashion%20editorial%20photography%20clean%20neutral%20aesthetic&width=400&height=300&seq=cat-jackets-01&orientation=landscape',
  },
  {
    key: 'categories.pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20light%20blue%20denim%20jeans%20folded%20neatly%20on%20a%20white%20linen%20cloth%20soft%20natural%20lighting%20minimalist%20apparel%20flat%20lay%20editorial%20photography%20clean%20composition%20warm%20neutral%20tones&width=400&height=300&seq=cat-pants-01&orientation=landscape',
  },
  {
    key: 'categories.headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20black%20baseball%20cap%20with%20minimal%20embroidery%20resting%20on%20a%20light%20stone%20surface%20soft%20natural%20daylight%20minimalist%20accessory%20photography%20clean%20studio%20background%20editorial%20product%20style&width=400&height=300&seq=cat-headwear-01&orientation=landscape',
  },
  {
    key: 'categories.sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20matching%20two%20piece%20athleisure%20set%20hoodie%20and%20joggers%20in%20soft%20sage%20green%20arranged%20flat%20on%20a%20white%20background%20soft%20daylight%20minimalist%20fashion%20editorial%20photography%20clean%20composition&width=400&height=300&seq=cat-sets-01&orientation=landscape',
  },
  {
    key: 'categories.underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Folded%20soft%20cotton%20underwear%20basics%20in%20neutral%20grey%20tones%20arranged%20on%20a%20clean%20white%20surface%20soft%20diffused%20natural%20light%20minimalist%20apparel%20photography%20editorial%20product%20style%20gentle%20shadows&width=400&height=300&seq=cat-underwear-01&orientation=landscape',
  },
  {
    key: 'categories.jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20folded%20sports%20jersey%20with%20white%20and%20red%20stripes%20on%20a%20clean%20light%20background%20soft%20natural%20studio%20light%20minimalist%20sportswear%20editorial%20photography%20high%20detail%20harmonious%20composition&width=400&height=300&seq=cat-jersey-01&orientation=landscape',
  },
  {
    key: 'categories.accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20minimal%20fashion%20accessories%20sunglasses%20watch%20and%20bracelet%20arranged%20on%20a%20light%20marble%20surface%20soft%20natural%20daylight%20minimalist%20flat%20lay%20editorial%20photography%20clean%20warm%20neutral%20aesthetic&width=400&height=300&seq=cat-accessories-01&orientation=landscape',
  },
  {
    key: 'categories.bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20tan%20leather%20crossbody%20bag%20standing%20on%20a%20clean%20white%20pedestal%20soft%20natural%20studio%20lighting%20minimalist%20accessory%20product%20photography%20gentle%20shadow%20editorial%20style%20high%20detail&width=400&height=300&seq=cat-bags-01&orientation=landscape',
  },
  {
    key: 'categories.belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20rolled%20brown%20leather%20belt%20with%20silver%20buckle%20placed%20on%20a%20light%20wooden%20surface%20soft%20natural%20daylight%20minimalist%20accessory%20photography%20clean%20composition%20warm%20neutral%20editorial%20style&width=400&height=300&seq=cat-belts-01&orientation=landscape',
  },
  {
    key: 'categories.perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20clear%20glass%20perfume%20bottle%20with%20golden%20amber%20liquid%20on%20a%20clean%20white%20surface%20soft%20natural%20light%20minimalist%20beauty%20product%20photography%20gentle%20reflection%20editorial%20style%20high%20detail&width=400&height=300&seq=cat-perfumes-01&orientation=landscape',
  },
  {
    key: 'categories.other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Various%20small%20lifestyle%20products%20wallet%20phone%20case%20and%20keychain%20arranged%20on%20a%20soft%20grey%20surface%20natural%20daylight%20minimalist%20flat%20lay%20editorial%20photography%20clean%20neutral%20composition&width=400&height=300&seq=cat-other-01&orientation=landscape',
  },
];

export default function CategorySection() {
  const { t } = useTranslation();
  const [selected, setSelected] = useState('');

  const handleSelect = () => {
    if (selected) {
      window.open(selected, '_blank', 'noopener,nofollow');
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('categories.title')}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              {t('categories.subtitle')}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mb-10 md:mb-14 max-w-xl mx-auto">
            <select
              value={selected}
              onChange={(e) => setSelected(e.target.value)}
              className="flex-1 px-4 py-3 bg-background-50 border border-background-200 rounded-md text-sm text-foreground-700 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent cursor-pointer"
            >
              <option value="">{t('dropdown.select_category')}</option>
              {categoryList.map((cat) => (
                <option key={cat.key} value={cat.url}>
                  {t(cat.key)}
                </option>
              ))}
            </select>
            <button
              onClick={handleSelect}
              disabled={!selected}
              className="px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {t('dropdown.go')}
            </button>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
            {categoryList.map((cat) => (
              <a
                key={cat.key}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col bg-white rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 hover:shadow-sm transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full h-24 sm:h-28 md:h-32 overflow-hidden">
                  <img
                    src={cat.image}
                    alt={t(cat.key)}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                </div>
                <div className="flex items-center justify-center gap-1.5 px-2 py-2.5 md:py-3">
                  <span className="text-xs md:text-sm font-semibold text-foreground-800 text-center group-hover:text-primary-600 transition-colors leading-tight">
                    {t(cat.key)}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}